exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".legal-section {\n  display: flex;\n  flex-wrap: wrap;\n  bottom: 30px;\n  margin-bottom: 30px;\n  text-align: center;\n  justify-content: center;\n  align-items: center; }\n\n.legal-text,\n.legal-divider {\n  color: #767676;\n  margin-left: 10px;\n  margin-right: 10px; }\n\n.legal-link {\n  color: #767676;\n  text-decoration: underline; }\n\n@media (max-width: 768px) {\n  .legal-divider {\n    display: none; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/legal-section/legal-section.scss
// module id = 1279
// module chunks = 0